var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

export { engineUserAgent as e };
//# sourceMappingURL=engine-user-agent.js.map
